import React, { useState } from "react";
import LazyDiv from "../lazy/lazydiv";
import "./full.css";
import CarouselContentLoader from "../loader/contentLoader";
import ReactPlayer from "react-player";
import global from "../../global";
const LiveFull = (props) => {
  const [loading, isLoading] = useState(true);
  const onLoader = () => {
    isLoading(false);
  };

  return (
    <LazyDiv orient={"landscape"} className={"liveFull"}>
      {loading ? <CarouselContentLoader></CarouselContentLoader> : ""}

      <div id="vidgyor" className="vgrPlayerContainer">
        <div id="closeButtonContainer" style={{ height: "100", width: "100%" }}>
          {global.LIVE === "VIDGYOR" ? (
            <iframe
              src={
                "https://static.vidgyor.com/player/vod/v6/html/rgb.html?accountId=vprism&profile=rgb&playerDivId=vidgyor&videoUrl=" +
                props.url
              }
              width="100%"
              height="100%"
              allow="autoplay"
              allowFullScreen
              title={"LiveFull"}
              onLoad={onLoader}
            ></iframe>
          ) : (
            <ReactPlayer
              url={`https://www.youtube.com/live/${props.url}`}
              width="100%"
              height="100%"
              playing={true}
              controls={true}
            />
          )}
        </div>
      </div>

      <script src="https://static.vidgyor.com/player/v12/js/vgr_util_src.min.js"></script>
    </LazyDiv>
  );
};

export default LiveFull;
